import React from 'react';
import css from './Content.module.scss';

export const Content = ({ children }) => {
  return <div className={css.root}>{children}</div>;
};
